import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../../../enums';

const Component = () => import('./LocalBrandViews.vue');

export default [
  // Route with menuId
  {
    path: buildChildURL(LocalMenuGroupRoutePathNames.MENUS, LocalMenuGroupRoutePathNames.MENU_ID),
    name: LocalMenuGroupRouteNames.BRAND_MENU,
    component: Component,
  },
  // Route without menuId
  {
    path: buildChildURL(LocalMenuGroupRoutePathNames.MENUS),
    name: LocalMenuGroupRouteNames.BRAND_MENUS,
    component: Component,
  },
] as RouteRecordRaw[];
